import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, Package, FileText, MessageSquare, Users, ShoppingCart, LogOut, ExternalLink } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a1668682-6cd0-4608-a6a8-d20136862eb0/artifacts/fhi5ktps_IMG_9483.jpeg";

const ITEMS = [
  { to: "/admin", label: "Panel", icon: LayoutDashboard, exact: true },
  { to: "/admin/products", label: "Ürünler", icon: Package },
  { to: "/admin/orders", label: "Siparişler", icon: ShoppingCart },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/contacts", label: "Mesajlar", icon: MessageSquare },
  { to: "/admin/dealers", label: "Bayi Başvuruları", icon: Users },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#030f26] text-[#fdfbf7] flex">
      <aside className="w-64 hidden md:flex flex-col border-r border-white/10 bg-[#020a1a] sticky top-0 h-screen">
        <Link to="/admin" className="flex items-center gap-3 p-6 border-b border-white/10">
          <img src={LOGO_URL} alt="" className="w-10 h-10 object-cover border border-white/10" />
          <div>
            <div className="font-serif text-lg leading-tight">Wünberg</div>
            <div className="text-[10px] uppercase tracking-widest text-[#d4af37]">Admin Panel</div>
          </div>
        </Link>
        <nav className="flex-1 p-4 space-y-1">
          {ITEMS.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.exact}
              data-testid={`admin-nav-${it.label}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${
                  isActive
                    ? "bg-[#d4af37]/10 text-[#d4af37] border-l-2 border-[#d4af37]"
                    : "text-[#a0aabf] hover:text-white hover:bg-white/5"
                }`
              }
            >
              <it.icon size={16} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-2 text-xs text-[#a0aabf] hover:text-[#d4af37]">
            <ExternalLink size={12} /> Siteyi Görüntüle
          </Link>
          <div className="text-xs text-[#a0aabf]">{user?.email}</div>
          <button onClick={doLogout} data-testid="admin-logout" className="flex items-center gap-2 text-sm text-[#a0aabf] hover:text-[#d4af37]">
            <LogOut size={14} /> Çıkış
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="md:hidden flex items-center justify-between p-4 border-b border-white/10">
          <Link to="/admin" className="font-serif text-lg">Wünberg Admin</Link>
          <button onClick={doLogout} className="text-sm text-[#a0aabf]"><LogOut size={16} /></button>
        </header>
        <main className="flex-1 p-6 md:p-10 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
